import { TESSearchField, TESSearchFields } from '../definitions';

export const smaExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
  {
    name: 'gender',
    type: 'Radio',
    options: ['male', 'female'],
  },
  {
    name: 'age',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'diagnosis',
    type: 'Checkbox',
    options: ['G12.0', 'G12.1'],
  },
  {
    name: 'diagnosisDate',
    type: 'Custom',
  },
  {
    name: 'medication',
    type: 'Custom',
  },
  {
    name: 'substance',
    type: 'Custom',
  },
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];
